import { request } from 'utils/request';
import {
  ICreateOrUpdateUserCompanyData,
  ICreateOrUpdateUserHiikoEnvironmentData,
} from './slice/types';

const userApi = {
  getUsersByCompany: (hiikoEnvironmentId: number, companyId: number) => {
    return request({
      url: `hiiko_environment/${hiikoEnvironmentId}/company/${companyId}/users`,
    });
  },
  getAllUsers: (hiikoEnvironmentId: number) => {
    return request({
      url: `hiiko_environment/${hiikoEnvironmentId}/users`,
    });
  },
  getUserById: (userId: number) => {
    return request({
      url: `user/${userId}`,
    });
  },
  getUserCompanies: (userId: number, envId: number) => {
    return request({
      url: `user/${userId}/companies`,
      params: {
        hiiko_environment_id: envId,
      },
    });
  },
  getUserCompanyPermissions: ({
    envId,
    companyId,
  }: {
    envId: number;
    companyId: number;
  }) => {
    return request({
      url: `user/company-permissions`,
      params: {
        company_id: companyId,
        hiiko_environment_id: envId,
      },
    });
  },
  getUserHiikoEnvironmentPermissions: (envId: number) => {
    return request({
      url: `user/hiiko-environment-permissions`,
      params: {
        hiiko_environment_id: envId,
      },
    });
  },
  createOrUpdateUserHiikoEnvironment: ({
    envId,
    data,
  }: {
    envId: number;
    data: ICreateOrUpdateUserHiikoEnvironmentData;
  }) => {
    return request({
      method: 'POST',
      url: `hiiko_environment/${envId}/users`,
      data,
    });
  },
  createOrUpdateUserCompany: ({
    envId,
    companyId,
    data,
  }: {
    envId: number;
    companyId: number;
    data: ICreateOrUpdateUserCompanyData;
  }) => {
    return request({
      method: 'POST',
      url: `hiiko_environment/${envId}/company/${companyId}/users`,
      data,
    });
  },
  removeUserFromEnvironment: ({
    envId,
    userId,
  }: {
    envId: number;
    userId: number;
  }) => {
    return request({
      method: 'DELETE',
      url: `hiiko_environment/${envId}/users/${userId}`,
    });
  },
};

export default userApi;
